import _ from 'lodash';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { convertDatasets } from 'src/utils/helper';
import styled from 'styled-components';
const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'), { ssr: true });

function SectionIndex({ id, className, data, ads, showAds }) {
  const router = useRouter();
  if (_.isEmpty(data?.dataSet)) return null;
  const bgImage = _.find(data?.dataSet, (el) => el?.key === 'background-image')?.value;
  const bgImageMobile = convertDatasets(data?.dataSet, 'background-image-mobile', true);
  const bgContentDesktop = convertDatasets(data?.dataSet, 'content-image-desktop', true);
  const bgContentMobile = convertDatasets(data?.dataSet, 'content-image-mobile', true);
  return (
    <SectionWrapper id={id} bgImage={bgImage} bgImageMobile={bgImageMobile || bgImage} className={className} $isHome={router.pathname === '/'}>
      <div className='container'>
        <img className='content-image --mobile' src={bgContentMobile} />
        <img className='content-image --desktop' src={bgContentDesktop} />
      </div>
      <div className='block-ads'>{(showAds && !_.isEmpty(ads)) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}</div>  
      {/* <div className='block-ads'>{(showAds && !_.isEmpty(ads)) && <DynamicAds position={KEY_ADS_POSITION.AD1X1} data={ads} />}</div>   */}
    </SectionWrapper>
  );
}

const SectionWrapper = styled.div`
    position: relative;
    width: 100vw;
    height: auto;
    background-image: url(${props => props.bgImage});
    background-size: cover;
    background-position: top right;
    background-repeat: no-repeat;
    @media (max-width: 768px) {
      background-image: url(${props => props.bgImageMobile});
    }
    .block-ads{
      min-height: ${props => props.$isHome ? '250px' : 'unset'};
      @media (max-width: 768px) {
        min-height: unset;
      }
    }
    .container {
     display: flex;
      flex-wrap: wrap;
      margin: auto;
      width: 100%;
      max-width: 1200px;
      margin: auto;
      height: auto;
      padding: 0 15px;
      justify-content: space-between;
      @media (max-width: 768px) {
       padding: 0 !important;
        
      }
    }
    .content-image {
        position: relative;
        width: 100%;
        &.--mobile {
          display: none;
        }
        &.--desktop {
          display: block;
        }
        @media (max-width: 768px) {
          &.--mobile {
            display: block;
          }
          &.--desktop {
            display: none;
          }
        } 
    }
`;
export default SectionIndex;
